<script>
    import Processing from './Processing';

    export default {
        mixins: [Processing],
        props: {
            url: {
                type: String,
                default: '/',
            },
            method: {
                type: String,
                default: 'post',
            },
        },
        methods: {
            getMethodParams(data, method) {
                if (method === 'post') {
                    return {};
                }
                return data ? data : this.requestData();
            },
            postMethodData(data, method) {
                if (method === 'get') {
                    return {};
                }
                return data ? data : this.requestData();
            },
            requestData() {
                return {};
            },
            startProcessing() {
                this.startCall();
                this.startProcessingEvent();
            },
            stopProcessing() {
                this.endCall();
                this.stopProcessingEvent();
            },
            startProcessingEvent() {
            },
            stopProcessingEvent() {
            },
            makeCall(success, failure, data) {
                this.startProcessing();
                this.makeRequest(success, failure, data);
            },
            makeRequest(success, failure, data, url, method) {
                axios.request({
                    url: url || this.url,
                    method: method = method || this.method,
                    params: this.getMethodParams(data, method),
                    data: this.postMethodData(data, method),
                }).then(success).catch(failure);
            },
        },
    };
</script>
